import { render, staticRenderFns } from "./ListeCommandes.vue?vue&type=template&id=400a835e&scoped=true&"
import script from "./ListeCommandes.vue?vue&type=script&lang=js&"
export * from "./ListeCommandes.vue?vue&type=script&lang=js&"
import style0 from "./ListeCommandes.vue?vue&type=style&index=0&id=400a835e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a835e",
  null
  
)

export default component.exports